import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Loading, EmptyState } from "@/components/common";
import { formatDateTime } from "@/lib/format";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ScrollText } from "lucide-react";

export default function AuditLog() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/audit-logs").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <PageHeader title="Audit Log" subtitle="Catatan aksi penting sistem. Tidak dapat diubah oleh pengguna biasa." testId="audit-header" />
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm">
        {!rows ? <Loading /> : rows.length === 0 ? <EmptyState title="Belum ada aktivitas" icon={ScrollText} /> : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader><TableRow><TableHead>Waktu</TableHead><TableHead>Pengguna</TableHead><TableHead>Role</TableHead><TableHead>Aksi</TableHead><TableHead>Entitas</TableHead><TableHead>ID</TableHead></TableRow></TableHeader>
              <TableBody>
                {rows.map((a) => (
                  <TableRow key={a.id} data-testid={`audit-row-${a.id}`}>
                    <TableCell className="text-xs text-slate-500">{formatDateTime(a.created_at)}</TableCell>
                    <TableCell className="font-medium">{a.user_name || "-"}</TableCell>
                    <TableCell className="text-xs text-slate-500">{a.user_role}</TableCell>
                    <TableCell><span className="rounded-md bg-indigo-50 px-2 py-0.5 text-xs font-medium text-indigo-700">{a.action}</span></TableCell>
                    <TableCell className="font-mono text-xs">{a.entity}</TableCell>
                    <TableCell className="font-mono text-[10px] text-slate-400">{a.entity_id}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </div>
    </div>
  );
}
